import React from 'react';
import AddSubCategory from '../../../components/Seggregation/AddSubCategory';

const AddSubCategoryPage = () =>{
    return(
        <div className='sub_category_page'>
            <AddSubCategory/>
        </div>
    )
}

export default AddSubCategoryPage;